// extracted by mini-css-extract-plugin
export default {"cannon":"About_cannon__2BJFx","content":"About_content__p4VIr","about":"About_about__9Wip1","intro":"About_intro__fjNI5","intro2":"About_intro2__E0Uuo"};